import React, { useState, useEffect, useCallback } from "react";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Snackbar from "../snackbar";
import UploadButton from "./UploadButton";
import UploadStatus from "./UploadStatus";
import _ from "lodash";
import ImageCropper from "./ImageCropper";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TopToolbar,
  RefreshButton,
  ReferenceField,
  TextField,
  SelectInput,
  DateField,
  ListButton,
  ShowButton,
  Edit,
  DeleteButton,
  SimpleForm,
  TextInput,
  NumberInput,
} from "react-admin";

const EmailerBannerEdit = ({ permissions, ...props }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // props.location.query.order_number

  const EditActions = ({ permissions, basePath, data, resource }) => (
    <TopToolbar>
      <RefreshButton />
      <ListButton basePath={basePath} />
      <DeleteButton basePath={basePath} record={data} resource={resource} />
      {/* <ShowButton basePath={basePath} record={data} /> */}
    </TopToolbar>
  );

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

  const [formSettings, setFormSettings] = useState("");
  // console.log('propssss=>', props.location.query.order_number);

  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage, setCroppedImage] = useState(undefined);
  const [bannerStatus, setBannerStatus] = useState(false);
  const [base64String, setBase64String] = useState("");
  const [receivedImage, setReceivedImage] = useState("");
  const [bannerPurpose, setBannerPurpose] = useState();
  const [imageFile, setImageFile] = useState("");
  const [fileDimension, setFileDimension] = useState({
    height: 0,
    width: 0,
  });
  const [fileError, setFileError] = useState(false);
  const [isImageSelected, setIsImageSelected] = useState(false);

  const [bannerLink, setBannerLink] = useState("");
  const [bannerLinkError, setBannerLinkError] = useState(true);

  const inputUpdatePhoto = React.useRef(null);
  const [fileExtError, setFileExtError] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [validationPurposeError, setValidationPurposeError] = useState(false);

  React.useEffect(() => {
    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";

    fetch(`${apiUrl}/${location?.pathname}`, {
      method: "GET",
      headers: {
        Authorization: userData._token,
        // "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        const responseData = json.data;
        if (responseData.image_data) {
          setIsImageSelected(true);
        }
        setReceivedImage(responseData.image_data);
        setBannerStatus(responseData.status);
        setBannerLink(responseData.link);
        setBannerPurpose(responseData.purpose);
      })
      .catch((error) => {
        console.log("error==>", error);
      });
  }, []);

  const sumbitForm = () => {
    // const splitBusinessId = business[0].id;
    setOnSaveDisabled(true);

    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;

    const formData = new FormData();
    formData.append("image_type", "mobile_app");
    formData.append(
      "image_data",
      receivedImage != "" ? receivedImage : imageFile
    );
    formData.append("purpose", bannerPurpose);
    formData.append("status", JSON.stringify(bannerStatus));
    formData.append("link", bannerLink);
    // formData.append('business', splitBusinessId)
    // const targetUrl = `${props.user._links.business.href}/proof_of_payments`;
    // props.addProofOfPay({ targetUrl, formData });
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "PUT";

    for (var key of formData.entries()) {
      console.log(key[0] + ", " + key[1]);
    }
    options.body = formData;
    fetch(`${apiUrl}/${location?.pathname}`, {
      method: "PUT",
      body: formData,
      headers: {
        Authorization: userData._token,
        // "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log(".............", json);
        setShowSnackbar(true);
        setOnSaveDisabled(false);
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      })
      .catch((error) => {
        console.log("error==>", error);
      });
  };

  const changeBannerLink = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setBannerLinkError(true);
    } else {
      setBannerLinkError(false);
    }
    setBannerLink(positionObject);
  };

  async function dataUrlToFile(dataUrl, fileName) {
    var arr = dataUrl.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], fileName, { type: mime });
  }

  const onUploadFile = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = inputUpdatePhoto.current?.files;

      const fileExtension =
        selectedFile &&
        selectedFile[0].name.substring(
          selectedFile[0].name.lastIndexOf(".") + 1
        );
      const maxSize = 1;
      const validFileTypes = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];

      if (selectedFile[0].size / 1024 / 1024 > maxSize) {
        setFileExtError(false);
        setSizeError(true);
        setFileError(false);
      } else if (validFileTypes.indexOf(fileExtension) === -1) {
        setSizeError(false);
        setFileExtError(true);
        setFileError(false);
      } else {
        setFileExtError(false);
        setSizeError(false);
        const reader = new FileReader();
        var img = new Image();

        reader.onload = function (event) {
          // file is loaded

          img.onload = function () {
            console.log(img.width, img.height);
            setFileDimension({
              height: img.height,
              width: img.width,
            });
          };

          img.src = reader.result;
        };

        // console.log("image height abd stuffs", event.target.files);
        reader.addEventListener("load", (event) => {
          const image = reader.result;

          if (img.height == 250 && img.width == 600) {
            const fileData = dataUrlToFile(image, "croppedImage").then(
              function (file) {
                setImageFile(file);
              }
            );
            setIsImageSelected(true);
            setCroppedImage(image);
            setFileError(false);
            setImageToCrop(image);
          } else if (img.height < 250 || img.width < 600) {
            console.log("inin here");
            event.target.value = null;
            setFileError(true);
            setIsImageSelected(false);
            setCroppedImage(undefined);
            setImageToCrop(undefined);
          } else {
            setFileError(false);
            setCroppedImage(undefined);
            setImageToCrop(image);
          }
        });

        reader.readAsDataURL(event.target.files[0]);
      }
    }
  };

  const changeBannerStatus = () => {
    setBannerStatus(!bannerStatus);
  };

  const purposeChange = (e) => {
    console.log("e >>>>>>>>>", e.target.value);
    if (
      e.target.value === "" ||
      e.target.value === undefined ||
      e.target.value === null ||
      !e.target.value.trim().length
    ) {
      setValidationPurposeError(true);
    } else {
      setValidationPurposeError(false);
    }
    setBannerPurpose(e.target.value);
  };

  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    setFormSettings(formSetting.proof_of_payment_form);
  }, []);

  // console.log('business id offfffffff', businessId);

  return formSettings ? (
    <Edit actions={<EditActions />} {...props} title="Emailer Banner Edit">
      {/* <SimpleForm redirect="list"> */}
      <div className={`proof-of-payment-form-page`}>
        <div className=" pop-order-number-input so-input">
          <label>
            Purpose<sup className="asterisk">*</sup>
          </label>
          <input
            className="form-control"
            type="text"
            name="Purpose"
            value={bannerPurpose || ""}
            onChange={purposeChange}
          />
          {validationPurposeError && (
            <p className="so-input-error">Please enter a Purpose</p>
          )}
        </div>

        <div className="pop-order-number-input">
          <label>
            <span>Link</span>
          </label>
          <input
            type="text"
            placeholder=""
            className="product-name-input"
            value={bannerLink}
            onChange={changeBannerLink}
          />
        </div>

        <div className="pop-order-number-input">
          <label>
            <span>Status</span>
          </label>
          <div
            className={`toggle-button-container ${
              bannerStatus ? "toggle-button-on" : ""
            }`}
          >
            <label className="switch">
              <input
                type="checkbox"
                checked={bannerStatus}
                onChange={changeBannerStatus}
              />{" "}
              <div></div>
            </label>
            <span className="switch-status">{bannerStatus}</span>
          </div>
        </div>

        {receivedImage != "" ? (
          <div className="pop-order-number-input">
            <label>
              <span>
                Banner Image<sup className="asterisk">*</sup>
              </span>
            </label>
            <div className="banner-uploaded-img">
              <img className="banner-img" src={receivedImage} />
              <button
                onClick={() => {
                  setReceivedImage("");
                  setIsImageSelected(false);
                }}
              >
                X
              </button>
            </div>
          </div>
        ) : (
          <div className="pop-order-number-input">
            <label>
              <span>
                Banner Image<sup className="asterisk">*</sup>
              </span>
            </label>
            <input
              type="file"
              accept=".png, .jpg, .jpeg"
              ref={inputUpdatePhoto}
              onChange={onUploadFile}
            />
            {fileError && (
              <div className="valid-file-upload-error">
                <p>
                  Please select image with dimensions as 600 pixels in width &
                  250 pixels in height
                </p>
              </div>
            )}
            {sizeError && (
              <div className="valid-file-upload-error">
                <p>Please select image with size less than 1mb</p>
              </div>
            )}
            {fileExtError && (
              <div className="valid-file-upload-error">
                <p>Please select image png , jpg or jpeg</p>
              </div>
            )}
            <div className="valid-file-upload">
              <p>Instructions :</p>
              <ul>
                <li>
                  Allowed file types: Images: JPG Image, JPEG Image, PNG Image
                </li>
                <li>Max file size (total): 1 MB</li>
                <li>
                  Image dimensions: 600 pixels in width & 250 pixels in height
                </li>
              </ul>
            </div>
            {(fileDimension.width > 600 || fileDimension.height > 250) && (
              <div>
                <ImageCropper
                  imageToCrop={imageToCrop}
                  onImageCropped={(croppedImage) => {
                    setCroppedImage(croppedImage[0]);
                    const newImage = new File(
                      [croppedImage[1]],
                      croppedImage[1].name,
                      { type: croppedImage[1].type }
                    );
                    setImageFile(newImage);
                    setIsImageSelected(true);
                    console.log("---------------", newImage);

                    //convert to base64
                    // var reader = new FileReader();
                    // let imageFile = "";
                    // reader.readAsDataURL(croppedImage[1]);
                    // reader.onloadend = function () {
                    //   setImageFile(reader.result);
                    //   console.log("Base64 String - ", imageFile);
                    // };
                  }}
                />
              </div>
            )}
            {(croppedImage ||
              (fileDimension.width == 600 && fileDimension.height == 250)) && (
              <div>
                <p className="cropped-image-heading">Cropped Image</p>
                <img alt="Cropped Img" src={croppedImage} />
              </div>
            )}
          </div>
        )}

        <div className="so-save-button">
          <button
            onClick={sumbitForm}
            disabled={!isImageSelected || onSaveDisabled || !bannerPurpose}
          >
            <span>Save</span>
          </button>
        </div>
        {showSnackbar && <Snackbar message="Element Created" />}
      </div>
      {/* </SimpleForm> */}
    </Edit>
  ) : (
    <div>loading</div>
  );
};

export default EmailerBannerEdit;
